import { lazy } from 'react';

const DwollaWelcomeConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {},
    },
  },
  routes: [
    {
      path: '/dwolla/intro',
      component: lazy(() => import('./DwollaWelcome')),
    },
  ],
};

export default DwollaWelcomeConfig;
